import { GET_AVERAGE_DAILY_CLOTHS_WASH_FAILURE, GET_AVERAGE_DAILY_CLOTHS_WASH_SUCCESS } from 'redux/constants/MTag';
import { onFailure, onSuccess } from './common';

const initStat = { data: [], error: false, errorData: '', isLoading: true };

export default (state = initStat, action) => {
	switch (action.type) {
		case GET_AVERAGE_DAILY_CLOTHS_WASH_SUCCESS:
			return onSuccess(state, action);
		case GET_AVERAGE_DAILY_CLOTHS_WASH_FAILURE:
			return onFailure(state, action);
		default:
			return { ...state };
	}
};
